import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCalibration } from 'app/dtos/calibration/createCalibration';
import { UpdateCalibration } from 'app/dtos/calibration/updateCalibration';
import { _isPersonId } from 'app/services/auth.service';
import { CalibrationReferenceDevicesService } from 'app/services/models/calibration-reference-devices.service';
import { CalibrationService } from 'app/services/models/calibration.service';
import { DeviceService } from 'app/services/models/device.service';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { PersonService } from 'app/services/models/person.service';
import { ProcedureService } from 'app/services/models/procedure.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-calibration-dialog',
  templateUrl: './update-calibration-dialog.component.html',
  styleUrls: ['./update-calibration-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateCalibrationDialogComponent implements OnInit {
  @Input() data;
  constructor(public activeModal: NgbActiveModal,
    private calibrationService: CalibrationService,
    private procedureService: ProcedureService,
    private personService: PersonService,
    private deviceService: DeviceService,
    private toastrService: ToastrService,
    private router: Router,
    private environmentalConditionService: EnvironmentalConditionService,
    private calibrationReferenceDeviceService: CalibrationReferenceDevicesService
  ) { }

  calibration: any = {};
  calibrationDevice: any = {};
  procedures: any[] = [];
  kindProcedures: any[] = []
  selectProcedureId: number;
  public basicPwdShow = false;
  refereceDevices: any[] = [];
  persons: any[] = [];
  selectedPersonId: number = null;

  selectedDevices: any[] = [];
  selectedDevice: any;

  date = new Date();
  date2 = new Date();

  environmentalContent: any[] = [];
  enviromentalContentId: number;

  isPlace: boolean = true;

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  selectedAcradtionOrganizationId = 1;
  akradetionOrganization = [
    { id: 1, name: "Türkak" },
    { id: 2, name: "NAC" },
    { id: 3, name: "İzlenebilirik" },
    { id: 4, name: "IAS" }
  ]
  async ngOnInit() {
    await this.getByIdCalibration(this.data);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getByIdCalibration(id) {
    const data = await this.calibrationService.getByIdCalibration(id);
    console.log(data);
    this.calibration = data;
    if (this.calibration) {
      const kindId = this.calibration.deliveryDevice?.kindId; // kindId'yi tanımla
      console.log("kindId:", kindId);

      await this.getAllEnvironmentalCondition(kindId);
      await this.getAllProcedure();
      await this.getAllPerson();
      await this.getAllReferenceDevice(kindId);
      await this.getByKindIdProcedures(kindId);

      this.date = new Date(this.calibration.calibrationDate);
      this.enviromentalContentId = this.calibration.environmentalCondition.id
      this.isPlace = this.calibration.isPlace;
      this.selectProcedureId = this.calibration.procedureId;
      this.selectedAcradtionOrganizationId = this.calibration.accreditationOrganization;
      this.calibration.calibrationReferenceDevices.forEach(element => {
        const device = this.refereceDevices.find(p => p.id === element.deviceId);
        if (device) {
          this.onDeviceSelect(device);
        } else {
        }
      });
    }
  }

  async getAllEnvironmentalCondition(kindId) {
    const data = await this.environmentalConditionService.getAllEnvironmentalCondition(0, 100, kindId);
    console.log(data);
    this.environmentalContent = data.environmental;

    this.enviromentalContentId = this.environmentalContent[0]?.id

  }

  async getAllProcedure() {
    const data = await this.procedureService.getAllProcedures(0, 3);
    this.procedures = data.procedures;
  }

  async getByKindIdProcedures(kindId) {
    const data = await this.procedureService.getByKindIdProcedures(kindId);
    this.kindProcedures = data;
    console.log(this.kindProcedures);

  }

  async getAllPerson() {
    const data = await this.personService.getAllCompaniesPersons(0, 500, 1);
    this.persons = data.persons.map(person => ({
      ...person,
      fullName: person.name + ' ' + person.lastName
    }));
    const pers = this.persons.find(p => p.id === Number(_isPersonId));
    this.selectedPersonId = pers.id ?? null;
  }

  async getAllReferenceDevice(kindId) {
    const data = await this.deviceService.getAllDevices(0, 1000, '', 1, kindId);
    console.log(data);
    this.refereceDevices = data.devices;
  }


  async onDeviceSelect(device: any) {
    if (!device) return;

    // Eğer cihaz zaten listede varsa uyarı ver
    const isAlreadySelected = this.selectedDevices.some(d => d.id === device.id);
    if (isAlreadySelected) {
      this.toastrService.warning("Bu cihaz zaten listeye eklenmiş!");
      this.selectedDevice = null;
      return;
    }

    // Eğer cihazın kalibrasyonu geçerliyse listeye ekle
    if (device.isCalibrationValid) {
      const isFromCalibration = this.calibration.calibrationReferenceDevices.some(
        (c) => c.deviceId === device.id
      );
      if (isFromCalibration) {
        this.selectedDevices.push(device);
        return;
      } else {
        //this.toastrService.info("backende istek at")
        const data = await this.calibrationReferenceDeviceService.calibrationReferenceDevices(device.id, this.calibration.id);
        if (data.status) {
          this.closeModal();
          this.selectedDevices.push(device);
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      }

      //this.selectedDevices.push(device);

    } else {
      this.toastrService.error("Bu cihazın kalibrasyon durumu pasif, bu yüzden referans cihaz olarak ekleyemezsin.");
    }

    this.selectedDevice = null;
  }

  isSaveDisabled(): boolean {
    return !this.enviromentalContentId || !this.selectProcedureId || !this.date ||
      !this.selectedPersonId || !this.selectedAcradtionOrganizationId;
  }

  async saveData() {
    const update = new UpdateCalibration();
    update.id = this.calibration.id;
    update.procedureId = this.selectProcedureId;
    update.personId = this.selectedPersonId;
    update.calibrationDate = this.date[0] ?? this.date;
    update.status = this.calibration.status;
    update.environmentalConditionId = this.enviromentalContentId;
    update.accreditationOrganization = this.selectedAcradtionOrganizationId;
    update.isPlace = this.isPlace;
    update.acceptanceDate = this.date2[0] ?? this.date2;

    console.log(update)
    const data = await this.calibrationService.updateCalibration(update);
    if (data.status) {
      this.closeModal();
      this.toastrService.success(data.message);
    } else {
      this.toastrService.error(data.message);
    }
  }
}